import { gql } from "@apollo/client";

export const LIST_CURRENCIES = gql`
  query listCurrencies {
    listCurrencies {
      currency
      name
    }
  }
`;

export const GET_EXCHANGE_RATE = gql`
  query getExchangeRate($fromCurrency: String!, $toCurrency: String!, $date: Date!) {
    getExchangeRate(filter: { fromCurrency: $fromCurrency, toCurrency: $toCurrency, date: $date })
  }
`;
